(() => {
    window.$ = jQuery;
    const SELECTOR_SLICK = '.list-of-steps__slide-wrapper';
    const SETTINGS_SLICK = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const initSlick = () => {
        const element = $(SELECTOR_SLICK);

        element.slick(SETTINGS_SLICK);
    };

    document.addEventListener('DOMContentLoaded', () => {
        initSlick();
    });
})()